import { render } from "./Datesbox.vue?vue&type=template&id=0f248bbe"
import script from "./Datesbox.vue?vue&type=script&lang=js"
export * from "./Datesbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\development\\projects\\crm\\vueApps\\bdflApp\\bdfl_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__